import { Car, plateSize, plateType } from '@/commonTypes';
import styles from '../styles.module.css';
import PlateCardHeader from './PlateCardHeader';
import PlateDetails from './PlateDetails';
import { ReactNode } from 'react';
import DropDownCard from './DropDownCard';

type PlateCardProps = {
  plate?: any;
  open: boolean;
  onToggle?: () => void;
  children?: ReactNode;
  aside?: ReactNode;
  childClass?: string;
  plateSize?: plateSize;
  plateType?: plateType;
  header?: ReactNode;
  plateBtnClass?: string;
};

export default function DropDownPlateCard({
  plate,
  open,
  onToggle,
  children,
  aside,
  childClass,
  plateSize,
  plateType,
  header,
  plateBtnClass = '',
}: PlateCardProps) {
  return (
    <DropDownCard
      plateBtnClass={plateBtnClass}
      onToggle={onToggle}
      open={open}
      aside={aside}
      header={
        header
          ? header
          : plate && (
              <PlateCardHeader
                plate={plate}
                open={open}
                plateSize={plateSize}
                plateType={plateType}
              />
            )
      }
      childClass={childClass}
    >
      <>
        {children ? (
          <div className={styles.detail}>{children}</div>
        ) : (
          plate && <PlateDetails plate={plate} />
        )}
      </>
    </DropDownCard>
  );
}
